<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="申请编号">
        <el-input
          v-model="query.apply_no"
          placeholder="申请编号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商户名称">
        <el-input
          v-model="query.merchant_name"
          placeholder="企业/经营者名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="申请类型">
        <el-select v-model="query.apply_type" placeholder="选择类型" clearable>
          <el-option label="企业" :value="1"></el-option>
          <el-option label="个人" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" placeholder="选择状态" clearable>
          <el-option label="待审核" value="pending"></el-option>
          <el-option label="已通过" value="approved"></el-option>
          <el-option label="已拒绝" value="rejected"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提交时间">
        <el-date-picker
          v-model="query.createTime"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #apply_type="{ row }">
        <el-tag size="small" v-if="row.apply_type === 1">企业</el-tag>
        <el-tag size="small" type="warning" v-if="row.apply_type === 2"
          >个人</el-tag
        >
      </template>
      <template #status="{ row }">
        <el-tag size="small" type="info" v-if="row.status === 'pending'"
          >待审核</el-tag
        >
        <el-tag size="small" type="success" v-if="row.status === 'approved'"
          >已通过</el-tag
        >
        <el-tag size="small" type="danger" v-if="row.status === 'rejected'"
          >已拒绝</el-tag
        >
      </template>
      <template #handle="{ row }">
        <el-button
          size="small"
          v-if="row.status === 'pending'"
          type="success"
          @click="openAudit(row, 'approved')"
          >通过</el-button
        >
        <el-button
          size="small"
          v-if="row.status === 'pending'"
          type="danger"
          @click="openAudit(row, 'rejected')"
          >拒绝</el-button
        >
        <el-button size="small" type="primary" @click="openInfo(row)"
          >详情</el-button
        >
      </template>
    </auto-table>

    <!-- 申请详情 -->
    <el-dialog title="申请详情" :visible.sync="infoShow" width="60%">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="申请编号">{{
          curRow.apply_no
        }}</el-descriptions-item>
        <el-descriptions-item label="申请类型">
          <el-tag size="small" v-if="curRow.apply_type === 1">企业</el-tag>
          <el-tag size="small" type="warning" v-if="curRow.apply_type === 2"
            >个人</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item label="商户名称">{{
          curRow.merchant_name
        }}</el-descriptions-item>
        <el-descriptions-item label="营业执照">
          <el-image
            v-if="curRow.license_no"
            style="width: 100px; height: 100px"
            :src="curRow.license_no"
            :preview-src-list="[curRow.license_no]"
          ></el-image>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="经营者/法定代表人">{{
          curRow.legal_name
        }}</el-descriptions-item>
        <el-descriptions-item label="证件号">{{
          curRow.legal_id_no
        }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{
          curRow.contact_name
        }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{
          curRow.contact_phone
        }}</el-descriptions-item>
        <el-descriptions-item label="所在地区">{{
          curRow.province + curRow.city + curRow.district
        }}</el-descriptions-item>
        <el-descriptions-item label="详细地址">{{
          curRow.address
        }}</el-descriptions-item>
        <el-descriptions-item label="主营行业">{{
          curRow.industry
        }}</el-descriptions-item>
        <el-descriptions-item label="申请业务">
          {{ bizTypesText(curRow.biz_types) }}
        </el-descriptions-item>
        <el-descriptions-item label="结算账户">{{
          curRow.settle_account_type === 1 ? "对公" : "对私"
        }}</el-descriptions-item>
        <el-descriptions-item label="结算账号">{{
          curRow.settle_account_no
        }}</el-descriptions-item>
        <el-descriptions-item label="结算户名">{{
          curRow.settle_account_name
        }}</el-descriptions-item>
        <el-descriptions-item label="签订协议">{{
          curRow.agreement_signed === 1 ? "是" : "否"
        }}</el-descriptions-item>
        <el-descriptions-item label="缴纳保证金">{{
          curRow.deposit_paid === 1 ? "是" : "否"
        }}</el-descriptions-item>
        <el-descriptions-item label="申请状态">
          <el-tag
            size="small"
            type="info"
            v-if="curRow.status === 'pending'"
            >待审核</el-tag
          >
          <el-tag
            size="small"
            type="success"
            v-if="curRow.status === 'approved'"
            >已通过</el-tag
          >
          <el-tag
            size="small"
            type="danger"
            v-if="curRow.status === 'rejected'"
            >已拒绝</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item label="审核备注">{{
          curRow.audit_remark || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="提交时间">{{
          curRow.create_time
        }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{
          curRow.audit_time || "-"
        }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="infoShow = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 审核 -->
    <el-dialog :title="auditTitle" :visible.sync="auditShow" width="40%">
      <el-form label-width="90px">
        <el-form-item label="审核备注">
          <el-input
            type="textarea"
            :rows="4"
            :placeholder="
              auditStatus === 'rejected' ? '请填写拒绝理由，必填' : '请输入审核备注'
            "
            v-model="audit_remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditShow = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Total: 0,
      query: {
        apply_no: "",
        merchant_name: "",
        apply_type: "",
        status: "",
        createTime: [],
      },
      Option: [
        { name: "申请编号", value: "apply_no" },
        { name: "商户名称", value: "merchant_name" },
        { name: "申请类型", value: "apply_type", type: "custom" },
        { name: "联系人", value: "contact_name" },
        { name: "联系电话", value: "contact_phone" },
        { name: "状态", value: "status", type: "custom" },
        { name: "提交时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom", width: "220px" },
      ],
      curRow: {},
      infoShow: false,
      auditShow: false,
      auditTitle: "",
      auditStatus: "",
      audit_remark: "",
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    getLabel(list, v) {
      for (let index = 0; index < this[list].length; index++) {
        if (this[list][index].value === v) {
          return this[list][index].label;
        }
      }
    },
    bizTypesText(value) {
      if (!value) return "-";
      const map = { 1: "线上商城", 2: "本地生活", 3: "平台服务" };
      return String(value)
        .split(",")
        .map((v) => map[v] || v)
        .join("、");
    },
    openInfo(row) {
      this.curRow = row;
      this.infoShow = true;
    },
    openAudit(row, status) {
      this.curRow = row;
      this.auditStatus = status;
      this.audit_remark = "";
      this.auditTitle = status === "approved" ? "通过申请" : "拒绝申请";
      this.auditShow = true;
    },
    submitAudit() {
      if (this.auditStatus === "rejected" && !this.audit_remark) {
        this.$message("拒绝时必须填写审核备注");
        return;
      }
      this.$axios({
        url: "/user/merchantApply/audit",
        data: {
          id: this.curRow.id,
          status: this.auditStatus,
          audit_remark: this.audit_remark,
          auditor_id: this.adminInfo.id,
        },
        method: "post",
      }).then((res) => {
        this.$message(this.auditStatus === "approved" ? "通过成功" : "拒绝成功");
        this.auditShow = false;
        this.getList(1);
      });
    },
    getList(v) {
      let page = v || 1;
      let params = {
        currentPage: page,
        pageSize: 10,
        apply_no: this.query.apply_no || null,
        merchant_name: this.query.merchant_name || null,
        apply_type: this.query.apply_type || null,
        status: this.query.status || null,
      };
      if (this.query.createTime !== null && this.query.createTime.length > 0) {
        params.start_time = this.query.createTime[0] + " 00:00:00";
        params.end_time = this.query.createTime[1] + " 23:59:59";
      }
      this.$axios({
        url: "/user/merchantApply/queryManagerListPage",
        params,
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>